<template lang="html">
  <div class="sign-up-bottom">
    <div class="sign-up-bottom-main sign-up-bottom-sign" v-if="vipExclusiveFlag && !hasBuy">

      <div class="sign-info">
        <div class="sign-info-price"  @click="$router.push('vip')">
          <p><span>￥{{signInfo.firstPrice}}</span><del>{{signInfo | priceFilter}}</del></p>
          <p v-if="signInfo.firstPrice !== signInfo.price">第二个月自动续费{{signInfo.price}}/月，可随时取消</p>
        </div>
        <div class="sign-info-button" @click="$emit('sign')">
          立即开通
        </div>
      </div>
    </div>
    <div class="sign-up-bottom-main" v-else>

      <div class="sign-up-bottom-price">
        <div class="sign-up-bottom-price-main">
            <span v-if="!isVip" class="sign-up-bottom-price-current"><span>{{ isInAct ? '活动价' : '售价' }}：¥</span><em>{{effectivePrice}}</em></span>
            <span v-else class="sign-up-bottom-price-current"><span>{{ isInAct ? '活动价' : 'WPS会员' }}：¥</span><em>{{effectiveVipPrice}}</em></span>

            <span v-if="!isVip && marketPrice > price" class="sign-up-bottom-price-del">市场价：¥{{marketPrice}}</span>
            <span v-else-if="isVip" class="sign-up-bottom-price-del">日常价：￥{{price}}</span>
        </div>
        <div class="sign-up-bottom-price-stage" v-if="priceStage">分期月供<span>￥{{priceStage}}</span>起</div>
      </div>

      <!-- 已购买 -->
      <template v-if="hasBuy">
        <ui-button
          class="sign-up-bottom-button"
          width="250"
          fontSize="36"
          type="normal"
          @click.native="$emit('learn')">立即学习</ui-button>
      </template>
      <template v-if="isAliIos && !hasBuy">
        <ui-button
          class="sign-up-bottom-button ali-button"
          type="normal"
          width="460"
          fontSize="28"
          @click.native="toast">请到才博APP进行购买</ui-button>
      </template>
      <!-- 未购买不是拼团 -->
      <template v-if="!pingAble && !hasBuy && !isAliIos">
        <div class="coupon-icon">
          <div class="countTime"  v-if="isInAct && countFlag > 0">
            <p>距结束仅剩:</p>
            <p>{{showCountTime}}</p>
          </div>
          <transition name="fade">
            <div class="coupon-icon-img" v-if="biggestCoupon">
              立减￥{{biggestCoupon}}
            </div>
          </transition>
          <ui-button
            class="sign-up-bottom-button"
            width="240"
            fontSize="36"
            type="normal"
            @click.native="$emit('buy')">立即~订阅</ui-button>
        </div>
      </template>
      <template v-if="pingAble && !hasBuy &&!isAliIos">
          <template v-if="!isGroupCourse">
            <div class="coupon-icon">
              <div class="countTime"  v-if="isInAct && countFlag > 0">
                <p>距结束仅剩:</p>
                <p>{{showCountTime}}</p>
              </div>
              <transition name="fade">
                <div class="coupon-icon-img" v-if="biggestCoupon">
                  立减￥{{biggestCoupon}}
                </div>
              </transition>
              <ui-button
                class="sign-up-bottom-button"
                width="240"
                fontSize="36"
                type="normal"
                @click.native="$emit('buy')">立即订阅</ui-button>
            </div>
          </template>
          <template v-else>
            <template v-if="!groupId || groupStatus === 0">
              <ui-button
                class="sign-up-bottom-button"
                type="red"
                @click.native="$emit('buyGroup')">发起拼课￥{{groupPrice}}</ui-button>
              <ui-button
                class="sign-up-bottom-button"
                width="240"
                type="normal"
                @click.native="$emit('buy')">原价购买</ui-button>
            </template>
            <template v-else>
              <ui-button
                class="sign-up-bottom-button"
                width="400"
                type="red"
                @click.native="checkGroup">查看拼课进度</ui-button>
            </template>
          </template>
      </template>
    </div>
    <div v-if="!isVip" class="sign-up-bottom-holder" :class="{ hasVipGuideBar: !isVip }"></div>
  </div>
</template>

<script>
import os from '@edu-fe/os'
import { isxxx } from '@mixins'
import UiButton from '../UI/Button.vue'
import SignUpVipBar from './SignUpVipBar'
import { setDate } from '../../lib/dateUtils'

export default {
  name: 'SignUpBottom',
  mixins: [isxxx],
  props: [
    'hasBuy', // 是否已购买
    'price', // 当前价格
    'priceDel', // 以往价格
    'priceStage', // 分期价格
    'isIos', // App需特殊处理
    'isAndroid',
    'isVip',
    'vipPrice',
    'vipDiscount',
    'marketPrice',
    'activityPrice',
    'isInAct',
    'isGroupCourse',
    'groupPrice',
    'groupId',
    'groupStatus',
    'pingAble',
    'biggestCoupon',
    'totalEndTime',
    'vipExclusiveFlag',
    'effectivePrice',
    'effectiveVipPrice',
    'signInfo'
  ],
  data () {
    return {
      showCountTime: '',
      countFlag: 0,
      timer: ''
    }
  },
  filters: {
    priceFilter (signInfo) {
      return signInfo.firstPrice < signInfo.price ? `￥${signInfo.price}` : ""
    }
  },
  computed: {
    os () {
      return os
    },
    isAliIos () {
      return os.type === 'ali' && !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    }
  },
  watch: {
    totalEndTime: {
      handler (e) {
        if (e > 0) {
          this.timer = setInterval(() => {
            if (typeof e === 'number') {
              e -= 1000
              this.showCountTime = setDate(e)
              this.countFlag = e
            }
          },1000)
        }
      },
      immediate: true
    }
  },

  methods : {
    toast () {
      window.location.href = 'https://itunes.apple.com/app/apple-store/id1439039386?pt=38515&ct=wpsdownload&mt=8'
    },
    checkGroup () {
      this.$router.push(`/group?groupId=${this.groupId}`)
    }
  },

  mounted () {
    // this.totalTime = this.totalEndTime
  },

  beforeDestroy () {
    window.clearInterval(this.timer)
  },

  components: {
    UiButton,
    SignUpVipBar
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.sign-up-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  $h: 118;

  &-main {
    @include fixed('lbw');
    height: use($h);
    border-top: 1px solid #E4E4E4;
    box-sizing: border-box;
    padding: 0 use(30);
    background-color: #fff;
    /*position: relative;*/
    &-free {
      width: rem(163);
      position: absolute;
      top: rem(-40);
      img {
        width: 100%;
      }
    }
  }
  &-sign {
    padding: 0;
    background: linear-gradient(to right, #FEB100, #FF690A);
    border-top: none;
    .sign-info {
      position: relative;
      padding-top: rem(10);
      padding-left: rem(30);
      padding-right: rem(30);
      &:after {
        content: '';
        display: block;
        clear: both;
      }
      &-price {
        float: left;
        position: relative;
        &:before {
          content: '会员专享课';
          position: absolute;
          font-size: rem(28);
          color: #fff;
          padding: rem(10) rem(25);
          display: block;
          background-color: #FF4040;
          text-align: center;
          border-radius: rem(18) rem(7) rem(7) rem(0);
          top: rem(-30);
          left: rem(140);
          font-weight: bold;
          width: rem(150);
        }
        p {
          font-size: rem(24);
          color: #fff;
          span {
            background: linear-gradient(to bottom, transparent 0%, #fff 1%, #FFE19C);
            background-clip: text;
            color: transparent;
            font-size: rem(63);
            font-weight: bold;
          }
          del {
            font-size: rem(28);
            color: #A53D08;
          }
        }
      }
      &-button {
        position: absolute;
        top: rem(15);
        right: rem(30);
        width: rem(200);
        height: rem(80);
        line-height: rem(80);
        text-align: center;
        font-size: rem(34);
        color: #490808;
        background-color: #FFDA1F;
        font-weight: bold;
        border-radius: rem(10);
      }
    }
  }
  // &-consult {
  //   float: left;
  //   @include square(140, 100%);
  //   @include center-box();
  //   img {
  //     display: block;
  //     @include square(59, 88);
  //   }
  // }
  .coupon-icon {
    position: relative;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    .countTime {
      float: left;
      color: #F59100;
      margin-left: rem(33);
      padding-left: rem(33);
      font-size: rem(24);
      height: rem(68);
      transform: translateY(rem(27));
      border-left: rem(2) solid #F1F0EE;
      line-height: 1.5;
      font-weight: bold;
    }
    &-img {
      position: absolute;
      color: #fff;
      box-sizing: border-box;
      font-size: rem(18);
      height: rem(38);
      padding: rem(5) rem(25);
      // line-height: rem(38);
      text-align: center;
      background: url('../../assets/images/coupon-icon.png');
      background-size: 100% 100%;
      right: rem(15);
      top: rem(10);
      line-height: rem(22);
    }
  }
  &-price {
    float: left;
    height: 100%;
    @include center-box();
    flex-direction: column;
    &-main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }
    &-current {
      color: #F93535;
      font-weight: bold;
      font-size: use(26);
      span {
        font-size: use(26);
        font-weight: normal;
      }

      em {
        font-size: use(40);
      }
    }
    &-del {
      color: #999999;
      font-size: use(24);
      text-decoration: line-through;
    }
    &-stage {
      margin-top: use(6);
      font-size: use(24);
      color: #999999;
      span {
        color: #FF6845;
      }
    }
  }

  &-button {
    float: right;
    margin-top: use(20);
    margin-left: use(20);
    font-weight: bold;
    &-view {
      width: rem(470);
      text-align: center
    }
  }
  &-holder {
    height: use($h);

    // &.hasVipGuideBar {
    //   padding-bottom: use(96);
    // }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
